import { boot } from 'quasar/wrappers'

interface RuntimeConfig {
  API_BASE_URL: string
  HEALTHCHECK_URL: string
  SENTRY_DSN: string | null
  SENTRY_ENVIRONMENT: string
  SENTRY_RELEASE: string
  SENTRY_TRACE_PROPAGATION_TARGET: string
  MAX_CHECKOUT_DURATION_MINUTES: number
  ANALYTIC_COLLECTION_ENABLED: boolean
  MATOMO_SITE_ID: number | null
  MATOMO_SERVER: string | null
}

let runtimeConfig: RuntimeConfig
export default boot(async ({ app }) => {
  runtimeConfig = await fetch(location.origin + '/config/runtime.json')
    .then((res) => res.json())
    .then((config) => config)

  app.config.globalProperties.$runtimeConfig = runtimeConfig
})

export { runtimeConfig }
